import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/decoration-old-woman.svg")